// import { createApp } from "vue";
// import router from "./router";
// import vuetify from "./plugins/vuetify";
// import "roboto-fontface/css/roboto/roboto-fontface.css";
// import "@mdi/font/css/materialdesignicons.css";
// import { format } from "date-fns";
import { createPinia } from "pinia";
// import VueCompositionAPI from "@vue/composition-api";
// import { localstoragePlugin } from "./store/plugins/localstoragePlugin";
// import { Authorizer } from "casbin.js";
// import CartVue from "./submodules/Cart.vue";
// import $ from "jquery";
// import { Casbin, CasbinPluginOptions } from "@/plugins/casbin";
// import AclMixin from "@/mixins/acl.mixin";
import { Services } from "./services/services";
import { createApp } from "vue";
import { vInfiniteScroll } from "@vueuse/components";
// import SearchApiService from "./services/services/apis/foxigy/search";

// Vue.config.productionTip = false;

// Vue.filter("formatDateTime", function (value: string): string {
//     if (!value) {
//         return "-";
//     }

//     return format(new Date(value), "dd.MM.yyyy kk:mm");
// });

// Vue.filter("formatDate", function (value: string): string {
//     if (!value) {
//         return "-";
//     }

//     return format(new Date(value), "dd.MM.yyyy");
// });

// Vue.use(VueCompositionAPI);
// Vue.use(PiniaVuePlugin);

// const authorizer = new Authorizer(
//     "auto",

//     { endpoint: "/api/v1/users/permissions/casbin", cacheExpiredTime: 18144000 }
// );

/*authorizer.setUser('user-60').then(() => {
  const result = authorizer.can("read", "User");
  result.then((success) => {
    console.log(success);
  }).catch(error => console.log(error));
});*/

// Vue.use(Casbin, {
//     authorizer: authorizer
// } as CasbinPluginOptions);

export const pinia = createPinia();
// provide(Symbol("pinia"), pinia);

// pinia.use(localstoragePlugin);

let environment: "production" | "development" = "production";

if (["profigarazs.s18.upgates.shop", "foxigy-dev.upgates.shop"].includes(window.location.host)) {
    foxigyPluginEnables = true;
    environment = "development";
}

export { environment };

export const vueApp = createApp(
    {},
    {
        // router,
        // vuetify,
        // pinia
    }
);
vueApp.directive("v-infinite-scroll", vInfiniteScroll);

if (foxigyPluginEnables === true) {
    defer(
        () => Boolean($),
        () => {
            // Vue.mixin(AclMixin);
            // const element = document.createElement("");

            const services = new Services();
            services.init();
            pinia.install(vueApp);
            const vueWebApp = services.vueWebAppService();

            vueWebApp.initSearchModule();
            // console.log("test");
        }
    );
}

// pinia.install(vueApp);
// vueApp;
// vueApp.mount("#app");

export function defer(condition: () => boolean, method: () => any) {
    if (condition()) {
        method();
    } else {
        setTimeout(function () {
            defer(condition, method);
        }, 50);
    }
}
